<template>
  <div class="Foot"
       ref="foot">
    <div class="botBlank"></div>
    <div class="botNav">
      <van-row>
        <van-col span="6">
          <a href="/mobile/"
             class="lis">
            <div class="imgbox">
              <img src="@/assets/bot1.png"
                   alt="">
            </div>
            <p>助学首页</p>
          </a>
        </van-col>
        <van-col span="6">
          <a href="/mobile/school-list/0"
             class="lis">
            <div class="imgbox">
              <img src="@/assets/bot2.png"
                   alt="">
            </div>
            <p>学校信息</p>
          </a>
        </van-col>
        <van-col span="6">
          <a href="/mobile/fuwuNav"
             class="lis">
            <div class="imgbox">
              <img src="@/assets/bot3.png"
                   alt="">
            </div>
            <p>服务中心</p>
          </a>
        </van-col>
        <van-col span="6">
          <a href="/mobile/news/23"
             class="lis">
            <div class="imgbox">
              <img src="@/assets/bot4.png"
                   alt="">
            </div>
            <p>新闻公告</p>
          </a>
        </van-col>
      </van-row>

    </div>

    <van-popup v-model="showMenu"
               position="bottom"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="botMenulist">
        <a :href="'/mobile'+item.link"
           class="lis"
           v-for="(item,index) in botMenuList"
           :key="index">
          {{item.name}}
        </a>
      </div>
    </van-popup>
    <van-popup v-model="showMenu2"
               position="bottom"
               class="botna"
               :style="{ height: '100%'}">
      <div class="botMenulist2">
        <div class="lis-cont">
          <div class="head">助学服务</div>
          <div class="cont">
            <a href="/mobile/shenqing/0">大学申请服务</a>
            <a href="/mobile/zhusu/1">住宿预定服务</a>
            <a href="/mobile/jieji/2">机场接机服务</a>
            <a href="/mobile/visa/3">签证服务</a>
            <a href="/mobile/jiaodui/4">论文核对服务</a>
            <a href="/mobile/baoxian/5">保险申请服务</a>
            <a href="/mobile/SIM-Card/6">手机卡申请服务</a>
          </div>
        </div>
        <div class="lis-cont">
          <div class="head">教育中心</div>
          <div class="cont">
            <a href="/mobile/yuyan/0">中文培训中心</a>
            <a href="/mobile/kaoshi/1">考试准备中心</a>
            <a href="/mobile/jiaocai/2">官方教材</a>
          </div>
        </div>
        <div class="lis-cont">
          <div class="head">旅行生活</div>
          <div class="cont">
            <a href="/mobile/shenghuo/0">生活中心</a>
            <a href="/mobile/lvxing/1">旅行中心</a>
            <a href="/mobile/qiuzhi/2">求职中心</a>
            <a href="/mobile/fankui/3">反馈留言</a>
            <a href="/mobile/faq/4">常见问题</a>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>


<script>
import axiosApi from "../api/api.js";

export default {
  name: 'Foot',
  props: {
  },
  data () {
    return {
      botMenuList: [],
      showMenu: false,
      showMenu2: false,
      newslist: []
    }
  },
  mounted () {
    axiosApi(
      'cate/1', {}, 'get'
    ).then((res) => {
      this.newslist = res.data
    })
    this.$store.commit('update_botnavHeight', this.$refs.foot.clientHeight)
  },
  methods: {
    onShowMenuList (id) {
      switch (id) {
        case 1:
          this.botMenuList = [
            { name: '关于助学', link: '/about/0' },
            { name: '我们的优势', link: '/about/1' },
            { name: '合作伙伴', link: '/about/2' },
            { name: '联系我们', link: '/about/3' }]
          break;
        case 2:
          this.botMenuList = [
            { name: '根据城市选择学院', link: '/school-list/1' },
            { name: '综合排名', link: '/school-list/0' },
            { name: '热门专业', link: '/school-list/1' },
            { name: '热门院校', link: '/school-list/2' }]
          break;
        case 3:
          this.botMenuList = [
            { name: '大学申请服务', link: '/news-list' },
            { name: '住宿预定服务', link: '/news-list' },
            { name: '机场接送服务', link: '/news-list' },
            { name: '签证', link: '/news-list' },
            { name: '公告', link: '/news-list' },
            { name: '论文校对服务', link: '/news-list' },
            { name: '学生保险', link: '/news-list' },
            { name: 'SIM卡', link: '/news-list' }]
          break;
        case 4:
          this.upadteNewslist()
          break;

        default:
          this.botMenuList = ['no data']
          break;
      }
      this.showMenu = true
    },
    upadteNewslist () {
      console.log(this.newslist)
      const arr = this.newslist
      let narr = []
      arr.forEach(function (item) {
        narr = [...narr, { name: item.title, link: '/news/' + item.id },]
      });
      this.botMenuList = narr
    }
  },
}
</script>

<style lang="scss" scoped>
.botBlank {
  height: 160px;
  width: 100%;
}
.botNav {
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  z-index: 99;
  height: 160px;
  padding-bottom: 20px;
  background-color: #263e65;
  .lis {
    padding: 20px 0;
    display: block;
    .imgbox {
      width: 50px;
      margin: auto;
    }
    p {
      margin-top: 15px;
      color: #fff;
      text-align: center;
    }
  }
}
.botMenulist {
  border-top: 10px solid #263e65;
  padding-bottom: 60px;

  .lis {
    display: block;
    padding: 20px;
    font-size: 28px;
    border-bottom: 1px solid #ebedf0;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.botMenulist2 {
  padding: 20px;
  padding-bottom: 60px;
  .lis-cont {
    border-top: 10px solid #263e65;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0px 0px 8px rgba($color: #000000, $alpha: 0.2);
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
    .head {
      font-size: 30px;
      font-weight: bold;
    }
    .cont {
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      a {
        width: 32%;
        font-size: 28px;
        line-height: 56px;
        margin-right: 2%;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>